import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./Lato-Regular.woff2";

export const LatoRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
